"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.freeTierConfig = void 0;
exports.freeTierConfig = {
    hasFreeTier: true,
};
